<div class="prose">
  <h1>
    {{ 'pages.start.welcome.title' | translate: { username: user?.name } }}
  </h1>
  <p>{{ 'pages.start.welcome.intro' | translate }}</p>

  <div class="grid grid-cols-3 gap-12 [&>a>*]:h-full">
    @if (user?.hasSnapshotAccess) {
      <a class="no-underline" [routerLink]="['/addresses']">
        <nz-card nzHoverable [nzCover]="addressesTemplate">
          <nz-card-meta
            [nzTitle]="'pages.addressMaster.title' | translate"
            [nzDescription]="'pages.addressMaster.teaser' | translate"
          />
        </nz-card>
        <ng-template #addressesTemplate>
          <div class="flex! items-center justify-center p-6">
            <svg-icon
              src="assets/icons/Maps_travel/marker-pin-01.svg"
              class="size-32 text-grey-500"
            />
          </div>
        </ng-template>
      </a>
    }
    @if (user?.hasSnapshotAccess) {
      <a class="no-underline" [routerLink]="['/snapshots']">
        <nz-card nzHoverable [nzCover]="snapshotsTemplate">
          <nz-card-meta
            [nzTitle]="'pages.snapshots.title' | translate"
            [nzDescription]="'pages.snapshots.teaser' | translate"
          />
        </nz-card>
        <ng-template #snapshotsTemplate>
          <div class="flex! items-center justify-center p-6">
            <svg-icon
              src="assets/icons/Images/camera-03.svg"
              class="size-32 text-grey-500"
            />
          </div>
        </ng-template>
      </a>
    }
    @if (user?.hasAssetAccess) {
      <a class="no-underline" [routerLink]="['/uploads']">
        <nz-card nzHoverable [nzCover]="uploadsTemplate">
          <nz-card-meta
            [nzTitle]="'pages.uploads.title' | translate"
            [nzDescription]="'pages.uploads.teaser' | translate"
          />
        </nz-card>
        <ng-template #uploadsTemplate>
          <div class="flex! items-center justify-center p-6">
            <svg-icon
              src="assets/icons/General/upload-01.svg"
              class="size-32 text-grey-500"
            />
          </div>
        </ng-template>
      </a>
    }
    @if (user?.hasAssetAccess) {
      <a class="no-underline" [routerLink]="['/uploads/upload-file']">
        <nz-card nzHoverable [nzCover]="uploadFileTemplate">
          <nz-card-meta
            [nzTitle]="'pages.uploadFile.title' | translate"
            [nzDescription]="'pages.uploadFile.teaser' | translate"
          />
        </nz-card>
        <ng-template #uploadFileTemplate>
          <div class="flex! items-center justify-center p-6">
            <svg-icon
              src="assets/icons/General/upload-02.svg"
              class="size-32 text-grey-500"
            />
          </div>
        </ng-template>
      </a>
    }
    @if (user?.hasAuditAccess) {
      <a class="no-underline" [routerLink]="['/clearings']">
        <nz-card nzHoverable [nzCover]="clearingsTemplate">
          <nz-card-meta
            [nzTitle]="'pages.clearings.title' | translate"
            [nzDescription]="'pages.clearings.teaser' | translate"
          />
        </nz-card>
        <ng-template #clearingsTemplate>
          <div class="flex! items-center justify-center p-6">
            <svg-icon
              src="assets/icons/General/check-verified-01.svg"
              class="size-32 text-grey-500"
            />
          </div>
        </ng-template>
      </a>
    }
  </div>
</div>
